import { useEffect, useState } from 'react';

interface Props {
  url: string;
}

export default function InformUrlDisplay({ url }: Props) {
  const [copyState, setCopyState] = useState<'idle' | 'copied' | 'failed'>('idle');

  useEffect(() => {
    if (copyState === 'idle') return;
    const id = setTimeout(() => setCopyState('idle'), 2000);
    return () => clearTimeout(id);
  }, [copyState]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopyState('copied');
    } catch {
      setCopyState('failed');
    }
  };

  return (
    <div>
      <span className="inline-flex items-center gap-2">
        <span className="font-mono break-all">{url}</span>
        <button
          type="button"
          onClick={copy}
          className={`text-xs ${
            copyState === 'failed'
              ? 'text-red-600 hover:text-red-800'
              : 'text-blue-600 hover:text-blue-800'
          }`}
        >
          {copyState === 'copied'
            ? 'Copied'
            : copyState === 'failed'
              ? 'Copy failed — select the text manually'
              : 'Copy'}
        </button>
      </span>
      <p className="mt-1 text-xs text-gray-400">
        Use this URL to point UniFi devices at your controller.
      </p>
    </div>
  );
}
